import './Achievements.css';
import { useEffect } from 'react';
import deanImg from './IMAGE/DEAN.jpeg';
import bestImg from './IMAGE/BEST.jpeg';

function Achievements({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const achievements = [
    {
      title: "Dean's Lister (4x)",
      desc: "Consistently recognized for highly commendable academic performance and maintaining a GWA that qualified for the Dean's List for four consecutive semesters.",
      org: "FAITH Colleges",
      year: "2023–2025",
      icon: "🏅",
      image: deanImg
    },
    {
      title: "Merit Award",
      desc: "Recipient of the Merit Award for demonstrated excellence in the STEM curriculum and outstanding participation in class activities.",
      org: "APEC Schools",
      year: "2023",
      icon: "🎖️"
    },
    {
      title: "Champion — Division Press Conference",
      desc: "Won first place in the highly competitive Division Press Conference for Sports Writing out of hundreds of participants across the division.",
      org: "DepEd Lipa Division",
      year: "2016",
      icon: "🏆"
    },
    {
      title: "2nd Place — Regional Press Conference",
      desc: "Represented the division and secured second place at the Regional level for Sports Writing, displaying excellence in journalism under pressure.",
      org: "DepEd CALABARZON",
      year: "2016",
      icon: "🥈"
    },
    {
      title: "With High Honors",
      desc: "Graduated with High Honors in recognition of outstanding academic achievements and consistent dedication to studies.",
      org: "Langka Elementary",
      year: "2012",
      icon: "🥇"
    },
    {
      title: "Best in Research",
      desc: "Recognized for outstanding research quality, strong analysis, and impactful presentation during capstone and academic research evaluations.",
      org: "FAITH Colleges",
      year: "2025",
      icon: "📚",
      image: bestImg
    }
  ];

  const featuredAchievement = achievements.find((item) => item.title === "Dean's Lister (4x)");
  const timelineAchievements = achievements.filter((item) => item.title !== "Dean's Lister (4x)");

  return (
    <div className="ach-page">
      {/* ── Header ── (removed for global navbar) */}

      {/* ── Hero Strip ── */}
      <div className="ach-hero-strip">
        <div className="ach-strip-inner">
          <p className="ach-strip-label">Excellence & Recognition</p>
          <h1 className="ach-strip-name">Academic Achievements</h1>
          <p className="ach-strip-role">Honors, awards, and milestones throughout my academic journey</p>
          <div className="hero-stats-row">
            <span className="hero-stat-pill">▸ 6 Awards & Honors</span>
            <span className="hero-stat-pill">▸ Dean's Lister (4x)</span>
            <span className="hero-stat-pill">▸ Division & Regional Level</span>
          </div>
          <div className="hero-watermark">★</div>
        </div>
      </div>

      <main className="ach-main">
        {featuredAchievement && (
          <section className="ach-featured-card">
            <div className="ach-featured-image-wrap">
              <img src={featuredAchievement.image} alt={featuredAchievement.title} className="ach-featured-image" />
            </div>
            <div className="ach-featured-content">
              <span className="ach-featured-badge">Top Award</span>
              <h2 className="ach-featured-title">Dean&apos;s Lister (4x)</h2>
              <p className="ach-featured-meta">
                FAITH Colleges - Academic Excellence Recognition - 2023 to 2025
              </p>
            </div>
          </section>
        )}

        <section className="ach-timeline">
          {timelineAchievements.map((item, idx) => (
            <article className="ach-timeline-item" key={idx}>
              <div className="ach-timeline-marker"></div>
              <div className="ach-timeline-card">
                <p className="ach-timeline-top">{item.year} · {item.org}</p>
                <h3 className="ach-timeline-title">{item.title}</h3>
                <span className="ach-timeline-tag">Award</span>
                <p className="ach-timeline-desc">{item.desc}</p>
                {item.image && (
                  <div className="ach-timeline-image-wrap">
                    <img src={item.image} alt={item.title} className="ach-timeline-image" />
                  </div>
                )}
              </div>
            </article>
          ))}
        </section>
      </main>

      {/* ── Footer ── */}
      <footer className="ach-footer">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="ach-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>
    </div>
  );
}

export default Achievements;
